export const _en = {
    name: {
        label: "Name"
    },
    uid: {
        label: "Code"
    },
    description: {
        label: "Description"
    },
    comment: {
        label: "Comment"
    },
    refRulesCategoryId: {
        label: "Category"
    },
    refGlobalStateId: {
        label: "State"
    },
    refRuleLevelId: {
        label: "Criticality"
    },
    refEngineRuleId: {
        label: "Linked constraint",
        tooltip: "The alert will  be computed based on the constraint"

    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    uid: {
        label: "Code"
    },
    description: {
        label: "Description"
    },
    comment: {
        label: "Commentaire"
    },
    refRulesCategoryId: {
        label: "Catégorie"
    },
    refGlobalStateId: {
        label: "État"
    },
    refRuleLevelId: {
        label: "Criticité"
    },
    refEngineRuleId: {
        label: "Contrainte de planification liée",
        tooltip: "L'alerte sera calculée en se basant sur la configuration de la contrainte de planification"
    }
};